export const redirectWA = (
	phoneNumber?: string,
	dialCode: string | undefined = undefined,
) => {
	if (phoneNumber) {
		// eslint-disable-next-line no-param-reassign
		if (dialCode === '52') dialCode = '521';
		window.open(
			`https://api.whatsapp.com/send?phone=${dialCode || ''}${phoneNumber}`,
			'_blank',
		);
	}
};
